import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useFeatureFlagSplit } from '@verantos-dev/core-utils';
import { LoadingSpinner } from '@verantos-dev/shared-components';

import { AnnotatorSelection } from './components/DashboardComponents/AnnotatorSelection';
import { BatchProgress } from './components/DashboardComponents/BatchProgress';
import { DashboardOverallProgress } from './components/DashboardComponents/DashboardOverallProgress';
import { MetricProjectsDropdown } from './components/MetricProjectsDropdown';
import { ProjectNotSelected } from './components/ProjectNotSelected';
import { useMetricDashboard } from './useMetricDashboard';

interface MetricDashboardProps {
  hideProjectSelector?: boolean;
}

export const MetricDashboard = ({ hideProjectSelector = false }: MetricDashboardProps = {}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    annotationProgressData,
    isAnnotationProgressDataLoading,
    annotationProgressBatchWiseData,
    isAnnotationProgressBatchWiseDataLoading,
    selectedProjectId,
  } = useMetricDashboard();
  // TODO: cleanup with cp_annotation_show_dashboard_loading_spinner ff
  const showLoadingSpinner = useFeatureFlagSplit(
    'cp_annotation_show_dashboard_loading_spinner'
  ) as boolean;
  const isLoading = isAnnotationProgressDataLoading || isAnnotationProgressBatchWiseDataLoading;
  return (
    <Box
      sx={{ p: theme.spacing(6), display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
    >
      {!hideProjectSelector && (
        <Box sx={{ mb: theme.spacing(12) }}>
          <Typography variant="h4">{formatMessage({ id: 'metrics.dashboard.title' })}</Typography>
        </Box>
      )}
      {!hideProjectSelector && <MetricProjectsDropdown />}
      <Box
        id="metrics-dashboard-content"
        sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
      >
        <AnnotatorSelection />
        {!hideProjectSelector && !selectedProjectId ? (
          <ProjectNotSelected />
        ) : showLoadingSpinner && isLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: '400px',
              alignItems: 'center',
            }}
          >
            <LoadingSpinner id="metricDashboardLoading" />
          </Box>
        ) : (
          <>
            <DashboardOverallProgress annotationProgressData={annotationProgressData} />
            <BatchProgress annotationProgressBatchWiseData={annotationProgressBatchWiseData} />
          </>
        )}
      </Box>
    </Box>
  );
};
